export const templatesIndex = {
  header: {
    title: "Modelos do WhatsApp",
    description:
      "Crie e edite modelos como no Meta (cabeçalho/corpo/rodapé/botões + prévia).",
    create: "Criar modelo",
  },
  notConnected:
    'Sua conta não tem o WhatsApp Business conectado (WABA). Conecte-o primeiro em "WhatsApp Business".',
  filters: {
    search: "Buscar",
    searchPlaceholder: "Buscar por nome...",
    status: "Status",
    all: "Todos",
    category: "Categoria",
    allFem: "Todas",
    language: "Idioma",
    refresh: "Atualizar",
  },
  list: {
    loading: "Carregando modelos...",
    emptyTitle: "Nenhum modelo",
    emptyText: "Tente alterar os filtros ou crie seu primeiro modelo.",
    baseBadge: "Base",
    edit: "Editar",
    duplicate: "Duplicar",
    deleteProtected: "Modelo base: não pode ser excluído",
    delete: "Excluir",
    prev: "← Anterior",
    next: "Próximo →",
  },
  preview: {
    noText: "(sem texto)",
    noContent: "Sem conteúdo",
  },
  time: {
    now: "Agora",
    minutesAbbr: "{n} min",
    hoursAbbr: "{n}h",
  },
  common: {
    close: "Fechar",
    cancel: "Cancelar",
  },
  editor: {
    createTitle: "Criar modelo",
    editTitle: "Editar modelo",
    sectionBasic: "Básico",
    name: "Nome (snake_case)",
    nameHintHtml:
      "Os espaços viram <code>_</code>. Apenas <code>a-z</code>, <code>0-9</code> e <code>_</code>.",
    language: "Idioma",
    category: "Categoria",
    sectionHeader: "Cabeçalho",
    enable: "Ativar",
    type: "Tipo",
    headerLocationHintHtml:
      "O cabeçalho LOCATION não leva texto nem exemplos no modelo. A localização (lat/lng + nome/endereço) é enviada quando a mensagem é entregue via <code>/messages</code>.",
    headerMediaHint:
      "Se você usar MEDIA, sua conta pode exigir exemplos/handles durante a revisão.",
    headerTextLabel: "Texto (máx. 60)",
    headerTextPlaceholder: "Ex.: Olá {{1}}, sua reserva está pronta.",
    insert: "Inserir",
    autoExample: "Exemplo automático",
    examplesHeader: "Exemplos (cabeçalho)",
    remove: "Remover",
    headerLocationNote: "Um card de mapa será enviado no início da mensagem.",
    headerMediaNote: "Este cabeçalho será exibido como um anexo (mídia).",
    sectionBody: "Corpo",
    bodyPlaceholder: "Escreva o conteúdo. Use {{1}}, {{2}}...",
    examplesBody: "Exemplos (corpo)",
    sectionFooter: "Rodapé",
    footerPlaceholder: "Texto curto (opcional, máx. 60)",
    sectionButtons: "Botões",
    addButton: "+ Adicionar",
    noButtons: "Sem botões (opcional).",
    buttonTextPlaceholder: "Texto do botão (máx. 25)",
    removeButton: "Excluir",
    previewTitle: "Prévia",
    viewPayload: "Ver o payload enviado ao Meta",
    metaDebug: "Resposta / erro do Meta (debug)",
    validReady: "Pronto para salvar.",
    validIncomplete: "Preencha os campos obrigatórios antes de salvar.",
    saving: "Salvando...",
    save: "Salvar",
  },
  delete: {
    title: "Excluir modelo",
    irreversible: "Esta ação não pode ser desfeita.",
    willDeletePre: "O modelo ",
    willDeletePost: " será excluído.",
    confirmLabel: "Digite o nome exato para confirmar:",
    confirmPlaceholder: "Digite o nome exatamente",
    confirmHint: "O botão é ativado quando o texto coincide exatamente.",
    deleting: "Excluindo...",
    confirmDelete: "Excluir permanentemente",
  },
  errors: {
    nameRequired: "O nome é obrigatório.",
    nameInvalid: "Formato inválido. Use apenas a-z, 0-9 e _.",
    headerRequired: "O texto do cabeçalho é obrigatório se o cabeçalho estiver ativado.",
    headerMax: "O texto do cabeçalho tem no máximo 60 caracteres.",
    bodyRequired: "O corpo é obrigatório.",
    bodyMax: "O corpo tem no máximo 1024 caracteres.",
    footerMax: "O rodapé tem no máximo 60 caracteres.",
    buttonTextRequired: "O texto do botão é obrigatório.",
    buttonTextMax: "No máximo 25 caracteres.",
    phoneInvalid: "PHONE_NUMBER deve ser E.164 (ex.: +34123456789).",
    urlInvalid: "A URL deve começar com http:// ou https://",
    loadDetail: "Não foi possível carregar os detalhes do modelo.",
    save: "Erro ao salvar o modelo.",
    deleteFailed: "Não foi possível excluir o modelo.",
  },
  duplicate: {
    defaultBody: "Cópia do modelo. Edite o conteúdo. Obrigado {{1}}.",
  },
};
